// In-memory store for the Findings prototype. Lets the Triage list and the
// Finding review page share state without Redux — updates from one surface
// trigger re-renders on the other via a tiny subscribe model.
// Swap for a real RTK Query/Redux slice once the backend is wired up.

import { useEffect, useState } from "react";
import { type Finding, MOCK_FINDINGS } from "./findings.shared";

let store: Finding[] = MOCK_FINDINGS.map((f) => ({ ...f }));
const listeners = new Set<() => void>();

const notify = () => {
  listeners.forEach((l) => l());
};

export const useFindings = (): Finding[] => {
  const [, setVersion] = useState(0);
  useEffect(() => {
    const fn = () => setVersion((v) => v + 1);
    listeners.add(fn);
    return () => {
      listeners.delete(fn);
    };
  }, []);
  return store;
};

export const getFinding = (id: number): Finding | undefined => store.find((f) => f.id === id);

export const updateFinding = (id: number, patch: Partial<Finding>): void => {
  store = store.map((f) => (f.id === id ? { ...f, ...patch, last_status_change_at: new Date().toISOString() } : f));
  notify();
};

export const addFindingComment = (id: number, author: string, body: string): void => {
  const at = new Date().toISOString();
  store = store.map((f) =>
    f.id === id ? { ...f, comments: [...f.comments, { author, at, body }], last_status_change_at: at } : f,
  );
  notify();
};
